// Third-Party Libraries
import { Borders, Row, Workbook, Worksheet } from "exceljs"

// Types
import type { SelectOptionType } from "types"
import type { DataType } from "../../types"

// Utils
import { getSummary } from "./getSummary"

export const exportExcel = async (
  data: DataType[],
  coaData: SelectOptionType[],
  coaFilter: string[]
) => {
  // Vars
  const summary = getSummary(data)
  const workbook = new Workbook()
  const worksheet = workbook.addWorksheet("Sheet 1")
  const columns = [
    "DATE",
    "NUMBER",
    "ACCOUNT",
    "SOURCE",
    "GROUP",
    "CONTACT",
    "DESCRIPTION",
    "REFERENCE",
    "DEBET",
    "CREDIT"
  ]
  worksheet.views = [{ showGridLines: false }]

  worksheet.mergeCells(2, 1, 1, columns.length)

  // Title
  makeTitle(worksheet)

  coaFilter.forEach((da, index) => {
    // Vars
    const selectedCoa = coaData.find(item => item.value === da)?.label ?? "-"
    const coaList = data.filter(item => item.coa_id === da)
    const summary = getSummary(coaList)

    if (coaList.length) {
      if (index > 0) {
        worksheet.addRow([" "])
      }
  
      worksheet.addRow([selectedCoa])
  
      const headers = worksheet.addRow(columns)
      headers.font = { bold: true }
      headers.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF8C308" },
        }
        cell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        }
      })
  
      let itemRow: Row
  
      const cellBorder: Partial<Borders> = {
        top: { style: "thin", color: { argb: "000000" } },
        left: { style: "thin", color: { argb: "000000" } },
        bottom: { style: "thin", color: { argb: "000000" } },
        right: { style: "thin", color: { argb: "000000" } },
      }
  
      coaList.forEach(la => {
        itemRow = worksheet.addRow([
          la.transaction_date,
          la.coa_code,
          la.coa_name,
          la.source,
          la.group,
          la.contact,
          la.description,
          la.referensi,
          la.debit,
          la.credit
        ])
  
        itemRow.eachCell((cell) => {
          cell.border = cellBorder
        })
      })

      worksheet.addRow([
        "Total",
        ...[...Array(7)].map(() => ""),
        summary.debit,
        summary.credit
      ])
    }
  })

  if (data.length) {
    worksheet.addRow([
      "Grand Total",
      ...[...Array(7)].map(() => ""),
      summary.debit,
      summary.credit
    ])
  }

  // create xlsx
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "transaction-detail.xlsx"
    a.click()
    URL.revokeObjectURL(url)
  })
}

function makeTitle(worksheet: Worksheet) {
  const titleCell = worksheet.getCell(1, 2)
  titleCell.value = "TRANSACTION DETAIL"
  titleCell.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true,
  }
  titleCell.font = { bold: true, size: 15 }

  worksheet.getColumn(2).width = 20
}